export default __webpack_public_path__ + "static/media/ablum-icon copy.053a4d81.svg";